<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'renovaciones'"
      [camposVisibles]="[
        'desde',
        'hasta',
        'ramo',
        'subramo',
        'selectFilter',
        'onlyPcyWithBalance'
      ]"
      [camposObligatorios]="['desde', 'hasta']"
      (filterChange)="onFilterChange($event)"
      [sLobName]="getSlobName()"
      [lobName]="getLobName()"
      [allowFutureDates]="true"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [data]="insuranceData"
  [config]="tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  [fechaCorte]="fechaCorte"
></app-insurance-table>
